import {
  MY_AUCTIONS_FETCH_COMPANY_MEMBERS,
  MY_AUCTIONS_DELETE_LISTING,
  MY_AUCTIONS_FETCH_LISTING_BIDS,
  MY_AUCTIONS_UPDATE_BID,
  MY_AUCTIONS_UPDATE_LOT_STATUS,
  MY_AUCTIONS_UPDATE_LOT_REJECT_BID,
  MY_AUCTIONS_FETCH_AUCTION,
  MY_AUCTIONS_UPDATE_AUCTION,
  MY_AUCTIONS_FETCH_LISTINGS,
  MY_AUCTIONS_FETCH_JEWELRY,
  MY_AUCTIONS_ADD_JEWELRY_TOGGLE_ALL_CHECKBOX,
  MY_AUCTIONS_ADD_JEWELRY_TOGGLE_CHECKBOX,
  MY_AUCTIONS_ADD_JEWELRY_RESET,
  MY_AUCTIONS_PLACE_BID,
  MY_AUCTIONS_LOT_CHANGE_DESCRIPTION,
  UPLOAD_FILE,
  RESET_UPLOAD_ERRORS,
  AUCTIONS_HIGHEST_BID_CHANGED,
  MY_AUCTIONS_GET_DEFAULT_INCREMENT_BID,
  MY_AUCTIONS_REACTIVATE_LISTING
} from 'constants/action-types';

const initialLot = {
  bids: [],
  bidsPagination: {},
  isBidsLoading: false
};

const initialAllJewelry = {
  jewelries: [],
  selectedJewelry: [],
  pagination: {}
};

const initialState = {
  auction: {
    title: '',
    auctionId: '',
    auctionType: null,
    itemType: null,
    startDate: null,
    endDate: null,
    viewStartDate: null,
    pendingDate: null,
    sendBidderEmailNotificationOnSale: false,
    maxBidRange: null,
    minBidRange: null,
    minReservePrice: null,
    extendClosingTime: '',
    auctionStatus: null,
    auctionTypeTitle: null,
    auctionStatusTitle: null,
    displayReserveMet: false,
    displayStartPrice: false,
    useBidIncrementRange: false,
    bidIncrementRanges: []
  },
  listings: {
    lots: [],
    auctionId: '',
    pagination: {},
    chosenFilters: {},
    isListingsLoading: false
  },
  isAuctionLoading: false,
  allJewelry: {
    ...initialAllJewelry
  },
  defaultBidIncrementRanges: [],
  uploadErrors: []
};

export const manageAuction = (state = initialState, action) => {
  switch (action.type) {
    case AUCTIONS_HIGHEST_BID_CHANGED: {
      const newListings = state.listings.lots.map(lot => {
        if (lot.listingId === action.payload.data.ListingId) {
          const newBids = lot.bids
            .map(b => ({
              ...b,
              isHighestBid: false
            }))
            .filter(b => b.bidId !== action.payload.data.BidId);

          return {
            ...lot,
            highestBidPrice: action.payload.data.BidPrice,
            endDate: action.payload.data.EndDateTime && action.payload.data.EndDateTime,
            bidCount: action.payload.data.BidCount,
            bids:
              newBids.length > 0
                ? [
                    ...newBids,
                    {
                      bidId: action.payload.data.BidId,
                      bidPercentOverReservePrice: action.payload.data.BidPercentOverReservePrice,
                      bidPrice: action.payload.data.BidPrice,
                      buyerMasterAccountId: null,
                      buyerCompanyName: action.payload.data.BuyerCompanyName,
                      buyerMasterContactId: null,
                      dateCreated:
                        action.payload.data.DateCreated && action.payload.data.DateCreated,
                      isHighestBid: true,
                      sellerRejected: action.payload.data.sellerRejected,
                      listingId: action.payload.data.ListingId
                    }
                  ]
                : lot.bids
          };
        }
        return lot;
      });
      return {
        ...state,
        auction: {
          ...state.auction,
          endDate:
            state.auction.auctionId === action.payload.data.AuctionId
              ? action.payload.data.EndDateTime
              : state.auction.endDate
        },
        listings: {
          ...state.listings,
          lots: newListings
        }
      };
    }
    case MY_AUCTIONS_PLACE_BID.success: {
      const newListings = state.listings.lots.map(lot => {
        if (lot.listingId === action.payload.listingId && action.payload.isHighestBid) {
          return {
            ...lot,
            highestBidPrice: action.payload.bidPrice,
            bidCount: action.payload.bidCount
          };
        }
        return lot;
      });
      return {
        ...state,
        listings: {
          ...state.listings,
          lots: newListings
        }
      };
    }
    case MY_AUCTIONS_FETCH_AUCTION.pending:
      return {
        ...state,
        isAuctionLoading: true
      };
    case MY_AUCTIONS_FETCH_AUCTION.success: {
      return {
        ...state,
        auction: action.payload,
        isAuctionLoading: false
      };
    }
    case MY_AUCTIONS_UPDATE_AUCTION.pending:
      return {
        ...state,
        isAuctionLoading: true
      };
    case MY_AUCTIONS_UPDATE_AUCTION.success:
      return {
        ...state,
        auction: action.payload,
        isAuctionLoading: false
      };
    case MY_AUCTIONS_REACTIVATE_LISTING.success: {
      const newListings = state.listings.lots.map(i => {
        if (i.listingId === action.payload.listingId) {
          return {
            ...i,
            status: action.payload.status,
            listingState: action.payload.listingState
          };
        }
        return i;
      });
      return {
        ...state,
        listings: {
          ...state.listings,
          lots: newListings
        }
      };
    }
    case MY_AUCTIONS_FETCH_LISTINGS.pending:
      return {
        ...state,
        listings: { ...initialState.listings, isListingsLoading: true }
      };
    case MY_AUCTIONS_FETCH_LISTINGS.success:
      return {
        ...state,
        listings: {
          auctionId: state.auction.auctionId,
          lots: action.payload.listings.map(l => ({ ...l, ...initialLot })),
          pagination: {
            ...state.listings.pagination,
            ...action.payload.pagination
          },
          chosenFilters: {
            ...state.listings.chosenFilters,
            ...action.payload.chosenFilters
          },
          isListingsLoading: false
        }
      };
    case MY_AUCTIONS_DELETE_LISTING.success:
      return {
        ...state,
        listings: {
          ...state.listings,
          lots: state.listings.lots.filter(l => l.listingId !== action.meta.listingId)
        }
      };

    case MY_AUCTIONS_UPDATE_LOT_STATUS.success:
      return {
        ...state,
        listings: {
          ...state.listings,
          lots: state.listings.lots.map(l =>
            l.listingId === action.meta.listingId
              ? {
                  ...l,
                  status: action.payload.status
                }
              : l
          )
        }
      };
    case MY_AUCTIONS_UPDATE_LOT_REJECT_BID.success:
      return {
        ...state,
        listings: {
          ...state.listings,
          lots: state.listings.lots.map(l =>
            l.listingId === action.meta.listingId
              ? {
                  ...l,
                  highestBidRejected: action.payload
                }
              : l
          )
        }
      };
    case MY_AUCTIONS_LOT_CHANGE_DESCRIPTION.success:
      return {
        ...state,
        listings: {
          ...state.listings,
          lots: state.listings.lots.map(l =>
            l.listingId === action.meta.listingId
              ? {
                  ...l,
                  jewelries: l.jewelries.map(i => ({ ...i, ...action.meta.data }))
                }
              : l
          )
        }
      };

    case MY_AUCTIONS_FETCH_LISTING_BIDS.success:
      return {
        ...state,
        listings: {
          ...state.listings,
          lots: state.listings.lots.map(l =>
            l.listingId === action.meta.listingId
              ? {
                  ...l,
                  bids: action.payload.bidResult.bids,
                  bidsPagination: action.payload.bidResult.pagination,
                  bidCount: action.payload.bidResult.pagination.totalRecordsFound
                }
              : l
          )
        }
      };
    case MY_AUCTIONS_FETCH_LISTING_BIDS.error:
      return {
        ...state,
        listings: {
          ...state.listings,
          lots: state.listings.lots.map(l =>
            l.listingId === action.meta.listingId
              ? {
                  ...l,
                  ...initialLot
                }
              : l
          )
        }
      };
    case MY_AUCTIONS_UPDATE_BID.success:
      return {
        ...state,
        listings: {
          ...state.listings,
          lots: state.listings.lots.map(l =>
            l.listingId === action.meta.listingId
              ? {
                  ...l,
                  bids: l.bids.map(b => (b.bidId === action.meta.bidId ? { ...action.payload } : b))
                }
              : l
          )
        }
      };

    case MY_AUCTIONS_FETCH_COMPANY_MEMBERS.success:
      return {
        ...state,
        approveAccounts: action.payload
      };
    case MY_AUCTIONS_FETCH_JEWELRY.success: {
      const newJewelrys = action.payload.jewelries.map(jewelry => ({
        ...jewelry,
        isSelected: state.allJewelry.selectedJewelry.includes(jewelry.rjLotId)
      }));
      return {
        ...state,
        allJewelry: {
          ...state.allJewelry,
          jewelries: newJewelrys,
          pagination: action.payload.pagination
        }
      };
    }
    case MY_AUCTIONS_ADD_JEWELRY_TOGGLE_ALL_CHECKBOX: {
      const newJewelrys = state.allJewelry.jewelries.map(jewelry => ({
        ...jewelry,
        isSelected: action.payload.checked
      }));
      return {
        ...state,
        allJewelry: {
          ...state.allJewelry,
          jewelries: newJewelrys,
          selectedJewelry: action.payload.checked
            ? [
                ...state.allJewelry.selectedJewelry,
                ...state.allJewelry.jewelries.map(j => j.rjLotId)
              ]
            : []
        }
      };
    }
    case MY_AUCTIONS_ADD_JEWELRY_TOGGLE_CHECKBOX:
      return {
        ...state,
        allJewelry: {
          ...state.allJewelry,
          jewelries: state.allJewelry.jewelries.map(jewelry => {
            if (jewelry.rjLotId === action.payload.id) {
              return {
                ...jewelry,
                isSelected: !jewelry.isSelected
              };
            }
            return jewelry;
          }),
          selectedJewelry: state.allJewelry.selectedJewelry.includes(action.payload.id)
            ? state.allJewelry.selectedJewelry.filter(jewelry => jewelry !== action.payload.id)
            : [...state.allJewelry.selectedJewelry, ...[action.payload.id]]
        }
      };
    case MY_AUCTIONS_ADD_JEWELRY_RESET:
      return {
        ...state,
        allJewelry: initialAllJewelry
      };
    case MY_AUCTIONS_GET_DEFAULT_INCREMENT_BID.success:
      return {
        ...state,
        defaultBidIncrementRanges: action.payload
      };
    case UPLOAD_FILE.pending:
    case RESET_UPLOAD_ERRORS:
      return {
        ...state,
        uploadErrors: []
      };
    case UPLOAD_FILE.error:
      return {
        ...state,
        uploadErrors: action.payload
      };
    default:
      return state;
  }
};
